import { RouteHead } from '@/components/seo/RouteHead';
import { ROUTES } from '@/routes';
import { LegalContent } from './LegalContent';

export default function TermsPage() {
  return (
    <>
      <RouteHead
        path={ROUTES.terms}
        titleKey="seo:terms.title"
        descriptionKey="seo:terms.description"
      />
      <LegalContent slug="terms" />
    </>
  );
}
